<div>
  <div>
    <p class="flex items-center justify-end text-green-500 text-md">
      <span class="font-bold">6%</span>
      <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 fill-current" viewBox="0 0 24 24">
        <path class="heroicon-ui"
              d="M20 15a1 1 0 002 0V7a1 1 0 00-1-1h-8a1 1 0 000 2h5.59L13 13.59l-3.3-3.3a1 1 0 00-1.4 0l-6 6a1 1 0 001.4 1.42L9 12.4l3.3 3.3a1 1 0 001.4 0L20 9.4V15z"/>
      </svg>
    </p>
  </div>
  <p class="text-3xl font-semibold text-center text-gray-800">43</p>
  <p class="text-lg text-center text-gray-500">New Tickets</p>
</div>
